import { ApexOptions } from 'apexcharts';
import { useTranslation } from 'react-i18next';

export const useStudyProgressChartsOptions = (currentExamsPassed: number, examsCount: number, totalExams: number, avgScore: number) => {
  const { t } = useTranslation();
  const examsPassedOptions: ApexOptions = {
    chart: {
      height: 370,
      type: 'radialBar',
    },
    series: [currentExamsPassed],
    colors: ['var(--theme-default)'],
    plotOptions: {
      radialBar: {
        hollow: {
          size: '65%',
        },
        track: {
          background: ['rgba(43, 94, 94, 0.1)'],
        },
        dataLabels: {
          name: {
            show: true,

            color: '#848789',
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: '"Nunito Sans", sans-serif',
          },
          value: {
            color: '#1f2f3e',
            fontSize: '20px',
            fontWeight: '700',
            fontFamily: '"Nunito Sans", sans-serif',
            show: true,
            formatter: (val) => `${examsCount} / ${totalExams}`,
          },
        },
      },
    },
    stroke: {
      lineCap: 'round',
    },
    responsive: [
      {
        breakpoint: 1600,
        options: {
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '14px',
                  offsetY: -8,
                },
                value: {
                  fontSize: '16px',
                },
              },
            },
          },
        },
      },
      {
        breakpoint: 360,
        options: {
          chart: {
            height: 250,
          },
        },
      },
    ],
    labels: [t('profilePage.charts.passedExams')],
  };

  const avgScoreOptions: ApexOptions = {
    series: [avgScore],
    chart: {
      height: 370,
      type: 'radialBar',
      offsetY: 0,
    },

    stroke: {
      dashArray: 25,
      curve: 'smooth',
      lineCap: 'round',
    },
    grid: {
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          size: '70%',
          image: '../assets/images/apexchart/radial-image.png',
          imageWidth: 140,
          imageHeight: 140,
          imageClipped: false,
        },
        track: {
          show: true,
          background: 'rgba(43, 94, 94, 0.1)',
          strokeWidth: '97%',
          opacity: 0.4,
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontSize: '16px',
            fontFamily: '"Nunito Sans", sans-serif',
            fontWeight: 600,
            color: undefined,
            offsetY: -10,
          
          },
          value: {
            show: true,
            fontFamily: '"Nunito Sans", sans-serif',
            fontWeight: 700,
            fontSize: '20px',
            color: '#1f2f3e',
            offsetY: 6,
            formatter: (val) => val + ' / 100',
          },
        },
      },
    },
    labels: [t('profilePage.charts.avgScore')],
    colors: ['var(--theme-default)', 'rgba(43, 94, 94, 0.1)'],
    // legend: {
    //   show: true,
    //   position: 'bottom',
    //   offsetY: -40,
    //   fontSize: '14px',
    //   fontFamily: '"Nunito Sans", sans-serif',
    //   fontWeight: 600,
    //   markers: {
    //     strokeWidth: 5,
    //   },
    //   onItemClick: {
    //     toggleDataSeries: false,
    //   },
    //   onItemHover: {
    //     highlightDataSeries: false,
    //   },
    // },
    responsive: [
      {
        breakpoint: 1600,
        options: {
          chart: {
            height: 340,
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
                imageWidth: 170,
                imageHeight: 170,
              },
              dataLabels: {
                name: {
                  fontSize: '14px',
                  offsetY: -8,
                },
                value: {
                  fontSize: '16px',
                },
              },
            },
          },
        },
      },
      {
        breakpoint: 676,
        options: {
          chart: {
            height: 350,
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '68%',
              },
            },
          },
        },
      },
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 320,
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
                imageWidth: 120,
                imageHeight: 120,
              },
            },
          },
        },
      },
      {
        breakpoint: 531,
        options: {
          chart: {
            height: 300,
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
                imageWidth: 100,
                imageHeight: 100,
              },
            },
          },
        },
      },
      {
        breakpoint: 426,
        options: {
          chart: {
            height: 280,
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
                imageWidth: 100,
                imageHeight: 100,
              },
            },
          },
        },
      },
    ],
  };

  return { examsPassedOptions, avgScoreOptions };
};
